import axios from 'axios';
import {
	utilityService
} from '@/services/utilityService.js';

function getConfigs () {
	// get configurations for studies and tables
	return axios.get(utilityService.getApiUrl(`ui/study/find?active=true`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

var appVersion = process.env.VUE_APP_VERSION;

export const configService = {
	getConfigs,
	appVersion
};
